<app-page-heading [heading]="'Claim Management'" [hasBackButton]="false"></app-page-heading>

<mat-tab-group class="tab-container"
               [selectedIndex]="activeTabIndex"
               (selectedTabChange)="onTabSelectionChanged($event)">
  
  <mat-tab [label]="TabLabel.Cases" [disabled]="!showCases">
    <ng-template matTabContent>
      <app-cases></app-cases>
    </ng-template>
  </mat-tab>
  
  <mat-tab [label]="TabLabel.Transactions">
    <ng-template matTabContent>
      <app-claims>
        <ng-container *ngIf="isAuthorised" buttons>
          <div>
            <button (click)="openFlowDiagram()" class="m-r-15" color="primary" mat-raised-button>
              <mat-icon>help_outline</mat-icon>
              Transaction Flow
            </button>
            
            <button *ngIf="showSubmitAuth" [routerLink]="'/claim-management/submit-authorisation'" class="m-r-15" color="accent" mat-raised-button>
              <mat-icon>add</mat-icon>
              Submit auth
            </button>

            <button *ngIf="showSubmitClaim"  [routerLink]="'/claim-management/submit-claim'" color="accent" mat-raised-button>
              <mat-icon>add</mat-icon>
              Submit Claim
            </button>
          </div>
        </ng-container>
        
        <ng-template #memberIconTpl let-personId>
          <app-death-status-icon [personId]="personId"></app-death-status-icon>
        </ng-template>
        
      </app-claims>
    </ng-template>
  </mat-tab>
  
  <mat-tab [label]="TabLabel.Payments" [disabled]="!showPayments">
    <ng-template matTabContent>
      <app-payments></app-payments>
    </ng-template>
  </mat-tab>

</mat-tab-group>
